import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {Subscription} from 'rxjs';
import {TranslateService} from "../../services/translate.service";
import {SchoolProgramModel} from "../../models/school-program-model";
import {SchoolProgramService} from "../../services/school-program.service";
import { SettingService } from '../../services/setting.service';

@Component({
  selector: 'app-select-school-program',
  templateUrl: './select-school-program.component.html',
  styleUrls: ['./select-school-program.component.css']
})
export class SelectSchoolProgramComponent implements OnInit, OnChanges, OnDestroy {

  localStorageName = 'client.spdata';
  heading = 'School program Select';
  loading: boolean;
  schoolProgramValue: SchoolProgramModel | null = null;
  schoolProgramList: SchoolProgramModel[] = [];

  @Output()
  schoolProgramChanged = new EventEmitter<SchoolProgramModel>();

  @Input()
  isDisabled = false;

  @Input()
  selectedProgramId: any = null;

  @Input()
  school_location_id: any = null;

  @Input()
  academic_year: any = null;

  @Input()
  usingLocalStorage = true;

  schoolProgramData :any = [];
  private programSub: Subscription | null = null;
  private loadedByChanges = false;
  constructor(
    private translate: TranslateService,
    private schoolProgramService: SchoolProgramService,
    private setting: SettingService,
  ) {
  }

  ngOnInit() {
    this.translate.load('extracurricular');
    // ngOnChanges already fetched with the bound inputs; don't hit again with an empty payload.
    if (!this.loadedByChanges) this.getSchoolPrograms();
  }

  ngOnDestroy(): void {
    this.programSub?.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes['school_location_id'] || changes['academic_year']) {
    //   this.schoolProgramValue = null;
    //   this.getSchoolPrograms();
    // }

    this.schoolProgramValue = null;
    this.loadedByChanges = true;
    if (this.school_location_id) {
      this.getSchoolPrograms();
    } else {
      this.programSub?.unsubscribe();
      this.schoolProgramChanged.emit(null);
      this.schoolProgramData = [];
      return;
    }

    if (changes['selectedProgramId']) {
      this.schoolProgramValue = this.schoolProgramData
        .find((i: SchoolProgramModel) => +i.school_program_id === +changes['selectedProgramId'].currentValue) || null;
    }
  }

  onChange(item: any) {
    if (!item) {
      // @ts-ignore
      this.schoolProgramChanged.emit(null);
      return;
    }
    this.schoolProgramChanged.emit(item);
    this.onSaveLocalStorage();
  }

  getSchoolPrograms() {
    const data = {
      school_location_id: this.school_location_id,
      academic_year: this.academic_year,
    }
    this.programSub?.unsubscribe();
    this.programSub = this.schoolProgramService.getSchoolProgram(data).subscribe((
        response: any) => {
      if(response['status']) {
        this.schoolProgramData = response['data'];
        if (this.selectedProgramId != null && !this.schoolProgramValue) {
          this.schoolProgramValue = (this.schoolProgramData || [])
            .find((i: SchoolProgramModel) => +i.school_program_id === +this.selectedProgramId) || null;
        }
        if (this.schoolProgramData) {
          this.onCheckLocalStorage();
        }
      } else {

      }
    })
  }

  onCheckLocalStorage() {
    if (!this.localStorageName) {
      return;
    }
    if (!this.usingLocalStorage) {
      return;
    }

    this.loading = false;
    const val = JSON.parse(<string>this.setting.getConfig(this.localStorageName));
    if (val) {
      // @ts-ignore
      this.schoolProgramValue = this.schoolProgramData
        .find((i: SchoolProgramModel) => i.school_program_id === val.school_program_id);
      if (this.schoolProgramValue) {
        this.schoolProgramChanged.emit(this.schoolProgramValue);
      }
    }
  }

  onSaveLocalStorage() {
    if (!this.usingLocalStorage) {
      return;
    }
    this.setting.setConfig(this.localStorageName, JSON.stringify(this.schoolProgramValue));
  }
}
